<template>
  <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" >
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        DATENSCHUTZERKLÄRUNG
      </v-card-title>
      <v-card-text>
        <dsgvo-content></dsgvo-content>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="closeDialog()"> I accept</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>

</template>

<script>
  import DsgvoContent from "../content/dsgvo-content";
  export default {
    name: "dsgvo",
    components: {DsgvoContent},
    watch: {
      visible(val) {
        this.dialog = val
      }
    },
    data() {
      return {
        dialog: true
      }
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      closeDialog() {
        this.$emit('closeDsgvo')
        this.dialog = false
      }
    },
    created() {
      this.dialog = this.visible
    }
  }
</script>

<style scoped>

</style>
